import React, { useState, useImperativeHandle } from 'react';
import BottomSheet, { BottomSheetProps } from 'src/components/BottomSheet';

export interface GlobalBottomSheetRef {
  open: (BottomSheetProps) => void;
  close: () => void;
}

const GlobalBottomSheet = React.forwardRef((props, ref) => {
  const [bottomSheetData, setBottomSheetData] = useState<BottomSheetProps>({
    visible: false,
  });

  useImperativeHandle(ref, () => ({
    open: (data: BottomSheetProps) => {
      setBottomSheetData(data);
    },
    close: () => {
      setBottomSheetData({ visible: false });
    },
  }));

  return <BottomSheet {...bottomSheetData} />;
});

export default GlobalBottomSheet;
